export const ADD_ON_SAVE_CALLBACK = 'ADD_ON_SAVE_CALLBACK'
export const addOnSaveCallback = (payload) => ({
  type: ADD_ON_SAVE_CALLBACK,
  payload,
})

export const CLEAR_ON_SAVE_CALLBACKS = 'CLEAR_ON_SAVE_CALLBACKS'
export const clearOnSaveCallbacks = (payload) => ({
  type: CLEAR_ON_SAVE_CALLBACKS,
  payload: {},
})
